import styled from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

import { Input } from 'components/Input';
import { Headline } from 'components/Headline';

const Container = styled.div`
  margin: 2rem;
  padding: 2rem;

  border: 0.2rem solid ${pickColor('blue')};
  border-radius: ${({ theme }) => theme.borderRadius.big};
`;

const Title = styled(Headline)``;

const InputGroup = styled.div`
  display: flex;
  gap: 10rem;

  margin-top: 2rem;
`;

const PanelInput = styled(Input)`
  flex-grow: 1;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;

  margin: 6rem 0 2rem 0;
`;

const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 2rem;

  flex-grow: 1;
`;

const InputLabel = styled(Headline)`
  margin-top: 1rem;
`;

export { Container, Title, Header, InputWrapper, InputGroup, PanelInput, InputLabel };
